import { Amazon } from '../../../../src/components/blog';
import * as React from 'react';
export default {
  Amazon,
  React
};